const isLoggingEnabled = process.env.REACT_APP_LOGGING_ENABLED === "true";

type LogFn = (...args: unknown[]) => void;

const noop: LogFn = () => {};

export const logger: Record<"log" | "warn" | "error" | "info" | "debug", LogFn> = {
  log: isLoggingEnabled ? console.log.bind(console) : noop,
  warn: isLoggingEnabled ? console.warn.bind(console) : noop,
  error: isLoggingEnabled ? console.error.bind(console) : noop,
  info: isLoggingEnabled ? console.info.bind(console) : noop,
  debug: isLoggingEnabled ? console.debug.bind(console) : noop,
};
